window.DiscussCancel = (function () {
    let self = {
        elements: {
            discussCancelForm: '#discuss-cancel',
            button: {
                cancelButton: '#discuss-cancel-cancel',
                nextButton: '#discuss-cancel-continue'
            },
            messages: {
                error: '#discuss-cancel-error'
            },
            selectBox: {
                cancellationReason: '#discuss-cancel-select-input'
            },
            textBox: {
                phoneNumber: '#discuss-cancel-phone'
            }
        },
        urls: {
            updateCancellationReason: '/api/sitecore/PolicyCancellation/SendDiscussPolicyCancellationDetails',
            managePlanPageUrl: '/my-health-insurance/manage-my-plan',
            successPageUrl: '/my-health-insurance/manage-my-plan/plan-cancellation/discuss-cancellation/request-submitted',
            errorPageUrl: '/error/error-page'
        },
        statusDescription: {
            accepted: 'accepted'
        },
        constants: {
            CharCodeUnitSeperator: 31,
            CharCodeNumericLowerBound: 48,
            CharCodeNumericUpperBound: 57
        },
        func: {
            init: function () {
                self.func.bindings();
            },
            bindings: function () {
                $(self.elements.discussCancelForm).on('submit', self.func.handleContinue);
                $('[data-input-restriction="decimal"]').on('input keypress keydown keyup drop', self.func.allowOnlyNumbers);
                $('[data-input-restriction="decimal"]').on('paste', self.func.allowPastingofNumbers);
            },
            allowOnlyNumbers: function (event) {
                let isControlCode = (event.charCode <= self.constants.CharCodeUnitSeperator);
                let isDecimalCode = (event.charCode >= self.constants.CharCodeNumericLowerBound &&
                    event.charCode <= self.constants.CharCodeNumericUpperBound);
                if (!isControlCode && !isDecimalCode) {
                    event.preventDefault();
                    return false;
                }
            },
            allowPastingofNumbers: function (event) {
                event.preventDefault();
                let clipData = event.originalEvent.clipboardData.getData('text');
                if (clipData) {
                    let filtered = clipData.replace(/[^0-9]/g, '');
                    event.target.value = filtered;
                }
            },
            handleContinue: function (event) {
                event.preventDefault();
                const phone = $(self.elements.textBox.phoneNumber).val();
                const reason = $(self.elements.selectBox.cancellationReason).val();
                $.ajax({
                    url: self.urls.updateCancellationReason,
                    type: 'PATCH',
                    data: { reason: reason, phone: phone},
                })
                    .done(function (response) {
                        if (response.statusCode.toLowerCase() === self.statusDescription.accepted) {
                            window.location.href = self.urls.successPageUrl;
                        } else {
                            window.location.href = self.urls.errorPageUrl;
                        }
                    });
            }
        }
    };

    return {
        Init: self.func.init
    };
})();

$(document).ready(function () {
    if ('discuss-cancel' === $('#discuss-cancel').data('feature')) {
        window.DiscussCancel.Init();
    }
});
